import { ActionTree } from 'vuex';
import { CastListState, RootState } from '@/store/types';
import {getCastList, getNewComerList} from "@/adapter/DbAdapter/castsAdapter";

const actions: ActionTree<CastListState, RootState> = {
    setCastList({ commit }, data) {
        commit('setCastList', data);
    },
    setNewCommerList({ commit }, data) {
        commit('setNewCommerList', data);
    },
    fetchCastList({commit}){
        return getCastList().then((res)=>{
            commit('setCastList', res)
            return res
        })
    },
    fetchNewCommerList({commit}){
        return getNewComerList().then((res)=>{
            commit('setNewCommerList', res);
            return res
        })
    }

};

export default actions;